import { useEffect, useState } from "react"
import { useAuth } from "../../../../context/AuthContext"
import { getFormattedStoreUrl, isTransferOrCrypto } from "../../../../lib/utils"
import {
	FiatParty,
	ShopifyInfo,
	TableOrder,
	TableOrderArs,
	TableOrderCrypto,
	TiendanubeInfo,
	WoocommerceInfo,
} from "../../../tables/transactions-table/data/types"
import ShopifyPaymentDetails, {
	getShopifyAdminUrl,
} from "./sections/ShopifyPaymentDetails"
import SuccessPaymentSummary from "./sections/SuccessPaymentSummary"
import SuccessPaymentTransactionDetails from "./sections/SuccessPaymentTransactionDetails"
import TiendanubePaymentDetails from "./sections/TiendanubePaymentDetails"
import WoocommercePaymentDetails from "./sections/WoocommercePaymentDetails"
import BodyBlock from "./BodyBlock"
import BodyItem from "./BodyItem"

const SuccessPaymentModalBody = ({
	payment,
	variant,
}:
	| {
			payment: TableOrderArs
			variant: "transfer"
	  }
	| {
			payment: TableOrderCrypto
			variant: "crypto"
	  }) => {
	const { stores } = useAuth()
	const [tiendanubeStore, setTiendanubeStore] = useState<any>()
	const [woocommerceStore, setWoocommerceStore] = useState<any>()
	const [shopifyStore, setShopifyStore] = useState<any>()

	useEffect(() => {
		if (!stores || !payment) return
		const store_id = payment.store?.store_id

		switch (payment.store?.store_type) {
			case "tiendanube":
				setTiendanubeStore(
					stores.find((store: any) => store.store_id === store_id)
				)
				break
			case "woocommerce":
				setWoocommerceStore(
					stores.find((store: any) => store.store_id === store_id)
				)
				break
			case "shopify":
				setShopifyStore(
					stores.find((store: any) => store.store_id === store_id)
				)
				break

			default:
				break
		}
	}, [stores, payment])
	return (
		<div className="grid grid-cols-1 items-center">
			{variant === "transfer" && (
				<SuccessPaymentSummary
					payment={payment as TableOrderArs}
					variant={variant}
				/>
			)}
			{variant === "crypto" && (
				<SuccessPaymentSummary
					payment={payment as TableOrderCrypto}
					variant={variant}
				/>
			)}
			<BodyBlock title={"Destino"}>
				{payment.recipient.type === "fiat" && payment.recipient.alias && (
					<BodyItem name="Alias" value={payment.recipient.alias} copy={true} />
				)}
				{payment.recipient.type === "fiat" && (
					<BodyItem
						name="CVU"
						value={payment.recipient.cvu}
						copy={true}
						overflow={true}
					/>
				)}

				{payment.paymentUrl && (
					<BodyItem
						name="Link de pago"
						value={payment.paymentUrl}
						copy={true}
						url={true}
					/>
				)}
			</BodyBlock>
			{variant === "crypto" && (
				<SuccessPaymentTransactionDetails
					payment={payment as TableOrderCrypto}
					variant={variant}
				/>
			)}
			{variant === "transfer" && (
				<SuccessPaymentTransactionDetails
					payment={payment as TableOrderArs}
					variant={variant}
				/>
			)}
			{payment.store?.store_type === "tiendanube" && (
				<TiendanubePaymentDetails
					info={payment.store as TiendanubeInfo}
					store_url={getFormattedStoreUrl(tiendanubeStore?.store_url)}
				/>
			)}
			{payment.store?.store_type === "woocommerce" && (
				<WoocommercePaymentDetails
					info={payment.store as WoocommerceInfo}
					store_url={getFormattedStoreUrl(woocommerceStore?.store_url)}
				/>
			)}
			{payment.store?.store_type === "shopify" && (
				<ShopifyPaymentDetails
					info={payment.store as ShopifyInfo}
					store_url={getShopifyAdminUrl(
						shopifyStore?.shopify_blob?.myshopifyDomain
					)}
				/>
			)}
		</div>
	)
}

export default SuccessPaymentModalBody
